var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5222 6.4378L11.9887 5.59255L9.50849 0.309547C9.32324 -0.0849531 8.67599 -0.0849531 8.49074 0.309547L6.01124 5.59255L0.47774 6.4378C0.0232398 6.50755 -0.15826 7.0603 0.16049 7.38655L4.18049 11.507L3.23024 17.3323C3.15449 17.795 3.64874 18.1423 4.05749 17.915L8.99999 15.1835L13.9425 17.9158C14.3475 18.1408 14.8462 17.8003 14.7697 17.333L13.8195 11.5078L17.8395 7.3873C18.1582 7.0603 17.976 6.50755 17.5222 6.4378Z",
    fill: "#FFC107"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarVector);
export default __webpack_public_path__ + "static/media/starVector.ab79178a51d35fe5c0fac04c81736b27.svg";
export { ForwardRef as ReactComponent };